import axios from "axios";
import { UpdateElements, UpdateType } from "./types";
import { FirmwareFilters, getFirmwares } from "../../../apiCalls/config/firmware";
import { ConfigFilters, getConfigs } from "../../../apiCalls/config/config";


type Params = {
  updateType: UpdateType | undefined;
  hardwareTypes: Iterable<string>;
  simTypes: Iterable<string | undefined>;
  extraFilters?: string[];
  count?: number;
  page?: number;
  query?: string;
};

export type FirmwareOrConfigPage = {
  data: UpdateElements[];
  hasNextPage: boolean;
};

export const fetchFirmwareOrConfigList = (
  { updateType, hardwareTypes, simTypes, extraFilters = [], count = 50, page = 1, query = "" }: Params
): Promise<FirmwareOrConfigPage> | null => {
  if (!updateType) return null;

  const { CancelToken } = axios;
  const hardwareTypesFilter = [...hardwareTypes]
    .map(v => `${FirmwareFilters.HardwareType}==${v}`)
    .join('&');
  const simTypesFilter = [...simTypes]
    .filter((v): v is string => v !== undefined)
    .map(v => `${ConfigFilters.SimType}==${v}`)
    .join('&');
  const filter = [hardwareTypesFilter, simTypesFilter, ...extraFilters]
    .filter(Boolean)
    .join('&');

  const req = updateType === UpdateType.firmware
    ? getFirmwares(query, page, CancelToken.source().token, hardwareTypesFilter, "", count)
    : getConfigs(query, page, CancelToken.source().token, filter, "", count);

  return req.then(res => ({
    data: res.data.data.map((x): UpdateElements => ({
      label: x.version,
      tags: x.tags,
      description: x.description,
      id: x.id,
      hardwareType: x.hardware_type,
      simType: x?.sim_type,
    })),
    hasNextPage: Boolean(res.data.has_next_page),
  }));
};